module.exports = [
  {
    path: "/company",
    name: "公司介绍",
    component: () => import("../../components/public/company.vue"),
  }
];
